import { Controller } from "@hotwired/stimulus"
import { showNotification, isTurboNativeApp } from "./helpers"

export default class extends Controller {
  static PUSH_PROMPT_RETRY_DAYS = 365

  connect() {
    console.log("turbo-app connect")
  }

  clearCache() {
    Turbo.cache.clear()
  }

  /** @param {Event & {type: "change", detail: {checked: boolean}}} event */
  changeBiometricLock(event) {
    const enabled = event.detail.checked
    const internalTester = event.params.internalTester
    window.TurboNativeBridge.postMessage("changeBiometricLock", { enabled })
    if (!internalTester) { // in new version mobile takes care of cookies
      document.cookie = `mobile_biometric_lock=${enabled | 0}; SameSite=Strict`
    }
  }

  changeBiometricSignin(event) {
    const enabled = event.detail.checked
    window.TurboNativeBridge.postMessage("changeBiometricSignin", { enabled })
  }

  sendQRCode(event) {
    const code = event.params.code
    window.TurboNativeBridge.postMessage("sendQRCode", { code })
  }

  share(event) {
    const message = event.params.message
    const type = event.params.type || "text"
    window.TurboNativeBridge.postMessage("share", { type, message })
  }

  sendReview() {
    window.TurboNativeBridge.postMessage("sendReview")
  }

  connectAccount(event) {
    if (navigator.userAgent.includes("Turbo Native")) {
      event.preventDefault()
      const provider = event.params.provider
      window.TurboNativeBridge.postMessage("connectAccount", { provider })
    }
  }

  showMessage(event) {
    showNotification(event.params.message)
  }

  requestPushPermission() {
    document.cookie = "mobile_push_permission=asked; path=/; SameSite=Strict"
    window.TurboNativeBridge.postMessage("requestPushPermission")
  }

  dismissPushPrompt() {
    const maxAge = this.constructor.PUSH_PROMPT_RETRY_DAYS * 24 * 60 * 60
    document.cookie = `mobile_push_permission=declined; path=/; max-age=${maxAge}; SameSite=Strict`
  }

  openUrl(event) {
    if (isTurboNativeApp() && navigator.userAgent.includes("Android")) {
      event.preventDefault()
      window.TurboNativeBridge.postMessage("openInBrowser", { url: event.target.href })
    }
  }
}
